import type { CustomPlanReason, CustomPlanRequestStatus } from '@/types/customPlanRequest';

export const REASON_LABELS: Record<CustomPlanReason, string> = {
  ad_revenue: 'Ads revenue',
  seats_total: 'Team seats',
  managers: 'Managers',
  executives: 'Executives',
  accounts: 'Business accounts',
  seller_central: 'Seller Central',
  vendor_central: 'Vendor Central',
  ams_profiles: 'Advertising profiles',
  marketing_stream: 'Marketing Stream',
  other: 'Something else',
};

export const STATUS_LABELS: Record<CustomPlanRequestStatus, string> = {
  open: 'Sent',
  in_review: 'In review',
  plan_ready: 'Ready to activate',
  activated: 'Active',
  rejected: 'Declined',
  cancelled: 'Withdrawn',
};

// The backend names connection resources in camelCase on CONNECTION_LIMIT_REACHED.
const CONNECTION_REASONS: Record<string, CustomPlanReason> = {
  accounts: 'accounts',
  sellerCentral: 'seller_central',
  vendorCentral: 'vendor_central',
  amsProfiles: 'ams_profiles',
  marketingStream: 'marketing_stream',
};

/** The reason to pre-tick from a CONNECTION_LIMIT_REACHED error body. */
export const reasonFromConnectionError = (body: any): CustomPlanReason =>
  CONNECTION_REASONS[body?.limit?.resource] ?? 'accounts';

/** The reason to pre-tick from a SEAT_LIMIT_REACHED error body. */
export const reasonFromSeatError = (body: any): CustomPlanReason => {
  const role = String(body?.limit?.role ?? '').toUpperCase();
  if (body?.limit?.scope === 'role' && role === 'MANAGER') return 'managers';
  if (body?.limit?.scope === 'role' && role === 'EXECUTIVE') return 'executives';
  return 'seats_total';
};

/** Opens the Request Custom plan modal from anywhere (e.g. the axios interceptor). */
export const REQUEST_CUSTOM_PLAN_EVENT = 'request-custom-plan';
